/** @jsx jsx */

import { Fragment as _, useState, useLayoutEffect, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import theGwillest from 'assets/the Gwillest.png';
import pubSub from 'services/pubSub';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import theresNothingHereYet from 'assets/Preview _No_interactions.svg';
import jumpStraightIn from 'assets/jumpStraightIn.svg';
import bluePlusSquare from 'assets/bluePlusSquare.svg';
import play_mint from 'assets/play_mint.svg';
import BlinkingLizard from 'assets/Blinking Lizard.svg';
import addInteractionBKG from 'assets/New Interaction V2.svg';
import { wizardOnboardingContainerQueryStyles } from './wizardOnBoardingContainerQueryStyles';

const Icon = ({
  icon,
  subIcon = '',
  width = 64,
  height = 64,
  color = '#333',
}) => {
  return (
    <div
      style={{
        position: 'relative',
        minWidth: width,
        minHeight: height,
      }}
    >
      <img src={icon} css={css({ minWidth: width, minHeight: height })} />

      {subIcon && (
        <div
          style={{
            position: 'absolute',
            width: 35,
            height: 35,
            right: 0,
            top: 0,
            transform: 'translate(50%, -50%)',
            borderRadius: '50%',
            background: `url('${subIcon}') no-repeat`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      )}
    </div>
  );
};

const hoverStyles = {
  cursor: 'pointer',
  boxShadow: '',
  transition: 'all 0.3s',

  ':hover': {
    opacity: 0.8,
    boxShadow: '0 0 0 5px #F5F6FB',
  },
};

const paddingStyles = {
  padding: '0 60px',
};

export const EmptySectionUpdatedForOnBoarding = () => {
  useLayoutEffect(() => {
    const head = document.querySelector('head');
    const style = document.createElement('style');

    style.innerHTML = wizardOnboardingContainerQueryStyles;

    head && head.appendChild(style);
  }, []);

  return (
    <div className="wizard-onboarding-root-scroll">
      <div
        className="wizard-onboarding-root"
        css={css({
          position: 'fixed',
          left: 0,
          top: 0,

          width: '100vw',
          height: '100vh',

          zIndex: 2147483647,

          fontFamily: 'Poppins',
          fontSize: 12,
          fontWeight: 300,

          h3: {
            margin: '0 0 10px 0',
            fontSize: 24,
            fontWeight: 500,
          },
        })}
      >
        <div className="wizard-onboarding-small-panel-container">
          <div
            className="wizard-onboarding-small-panel"
            css={css({
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              background: '#E5FBFB',
              borderRadius: 18,
              margin: '10px 10px 5px 10px',
              padding: '30px 0',
              //
              ...hoverStyles,
              //
            })}
            onClick={e => {
              pubSub.publish('SHOW_GETTING_STARTED_VIDEO', {
                showGettingStartedVideo: true,
              });
            }}
          >
            <div
              className="wizard-onboarding-small-panel-content"
              css={css({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...paddingStyles,
              })}
            >
              <Icon icon={play_mint} subIcon={theGwillest} />
              <div style={{ marginLeft: 30 }}>
                <h3>Demo Video</h3>

                <div className="wizard-instruction">
                  Watch a 101 on how to get started.
                </div>
              </div>
            </div>
          </div>
          <div
            className="wizard-onboarding-small-panel"
            css={css({
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              background: '#F5F0FF',
              borderRadius: 18,
              margin: '10px 10px 5px 10px',
              padding: '30px 0',
              //
              ...hoverStyles,
            })}
            onClick={() => {
              pubSub.publish('SHOW_ONBOARDING_WIZARD', {
                show: true,
                intro: 'hidden',
              });
            }}
          >
            <div
              className="wizard-onboarding-small-panel-content"
              css={css({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...paddingStyles,
              })}
            >
              <img src={BlinkingLizard} style={{ width: 80 }} />
              <div style={{ marginLeft: 30 }}>
                <h3>Design Wizard</h3>
                <div className="wizard-instruction">
                  Get a helping hand! Set a style and apply your brand up front!
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="wizard-onboarding-large-panel"
          css={css({
            flex: 1,
            height: '50%',
            margin: '15px 10px 10px 10px',
            background: '#EDF5FF',
            borderRadius: 18,
            //
            ...hoverStyles,
          })}
          onClick={e => {
            parent.setNewSectionWizard && parent.setNewSectionWizard(true);
          }}
        >
          <div
            css={css({
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              height: '100%',
            })}
          >
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                height: 'inherit',
                padding: '30px',
              }}
            >
              <img
                src={jumpStraightIn}
                style={{
                  height: 'inherit',
                  width: 'auto',
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
                padding: 30,
              }}
            >
              <div>
                <h3>Start from scratch</h3>

                <div>
                  Dive straight in and build an interaction on a blank canvas.
                </div>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',

                padding: 30,
              }}
            >
              <Icon icon={bluePlusSquare} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddInteractionBtn = ({ color = '#1D2026', hoverColor = '#488CDE' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      css={css({
        position: 'relative',
        cursor: 'pointer',
        fill: 'none',
        ':hover': {
          '.actual-btn': {
            fill: hoverColor,
          },
        },
      })}
    >
      <rect
        className="actual-btn"
        width="60"
        height="60"
        rx="12"
        css={css({
          fill: color,
          transition: 'fill 0.2s',
        })}
      />
      <rect x="28" y="18" width="4" height="24" fill="white" />
      <rect
        x="18"
        y="32"
        width="4"
        height="24"
        transform="rotate(-90 18 32)"
        fill="white"
      />
    </svg>
  );
};

export const EmptySection = () => {
  const moduleHasInteractions = useSelector((state: State) => {
    return Object.values(state.blocks)
      .filter(b => {
        return b?.meta?.subType === 'Interaction';
      })
      .some(i => {
        return i?.children?.length;
      });
  });

  if (window?.dev()) {
    return !moduleHasInteractions ? (
      <EmptySectionUpdatedForOnBoarding />
    ) : (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '50%',
            height: '50%',
            background: `url('${addInteractionBKG}') no-repeat`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          }}
        />
        <button
          style={{
            all: 'unset',
            position: 'relative',
            width: 60,
            height: 60,
          }}
          onClick={e => {
            parent.setNewSectionWizard && parent.setNewSectionWizard(true);
          }}
        >
          <AddInteractionBtn color="#4F9FFF" />
        </button>
        <div
          style={{
            position: 'relative',
            top: '15px',
            textAlign: 'center',
            color: '000',
            fontWeight: 500,
          }}
        >
          Add an interaction.
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <_>
        <div
          style={{
            width: '50%',
            height: '50%',
            background: `url('${theresNothingHereYet}') no-repeat`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          }}
        />
      </_>
    </div>
  );
};

export default EmptySection;
